/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BatchFileInfo
 */
export interface BatchFileInfo {
    /**
     * 
     * @type {string}
     * @memberof BatchFileInfo
     */
    caseFileId?: string;
    /**
     * 
     * @type {string}
     * @memberof BatchFileInfo
     */
    processingResultText?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BatchFileInfo
     */
    processingSuccess?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof BatchFileInfo
     */
    pageCount?: number;
    /**
     * 
     * @type {number}
     * @memberof BatchFileInfo
     */
    duration?: number | null;
}

export function BatchFileInfoFromJSON(json: any): BatchFileInfo {
    return BatchFileInfoFromJSONTyped(json, false);
}

export function BatchFileInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchFileInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'caseFileId': !exists(json, 'caseFileId') ? undefined : json['caseFileId'],
        'processingResultText': !exists(json, 'processingResultText') ? undefined : json['processingResultText'],
        'processingSuccess': !exists(json, 'processingSuccess') ? undefined : json['processingSuccess'],
        'pageCount': !exists(json, 'pageCount') ? undefined : json['pageCount'],
        'duration': !exists(json, 'duration') ? undefined : json['duration'],
    };
}

export function BatchFileInfoToJSON(value?: BatchFileInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'caseFileId': value.caseFileId,
        'processingResultText': value.processingResultText,
        'processingSuccess': value.processingSuccess,
        'pageCount': value.pageCount,
        'duration': value.duration,
    };
}


